module.exports = __webpack_public_path__ + "static/media/aboutUs_11.51cee569.jpg";